import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  TabIndicator,
  Flex,
  Text,
  Image,
  Button,
  Avatar,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import noMessage from "@/assets/images/nomessage2.png";
import sysAvatar from "@/assets/images/sys_avatar.png";
import SysMsgModal from "@/components/messageCenter/sysMsgModal";
import { useEffect, useState } from "react";
import PrivateLetterModal from "@/components/privateLetterModal";
import PrivateLetterItem from "@/components/messageCenter/privateLetterItem";
import { MsSystem } from "@/types/mssystem";
import { format } from "date-fns";
import {
  useLazyGetMsSystemQuery,
  useReadMsSystemMutation,
} from "@/services/api/endpoints/mssystem";
import { useSelector } from "react-redux";
import { selectUnReadMsSystemNum, selectUser, updateUnReadMsSystemNum } from "@/reducer/userslice";
import { useLazyGetMsUserByToIdQuery } from "@/services/api/endpoints/msuser";
import {
  useCreateFollowMutation,
  useDeleteFollowMutation,
  useLazyGetFansQuery,
  useLazyGetFollowsQuery,
} from "@/services/api/endpoints/follow";
import { Follow } from "@/types/follow";
import { ServerError } from "@/types/errors";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

const MessagesCenter = () => {
  const dispatch = useAppDispatch();
  const sysMsgControl = useDisclosure();
  const prvLetterControl = useDisclosure();
  const toast = useToast();
  const user = useSelector(selectUser);
  const userId = user.id;

  const [currentMsg, setCurrentMsg] = useState<MsSystem>();
  const [currentLetterUserId, setCurrentLetterUserId] = useState<string>("");
  const [tabIndex, setTabIndex] = useState(0);

  const [getMsSystem, { data: systemMsg }] = useLazyGetMsSystemQuery();
  const [readMsSystem] = useReadMsSystemMutation();
  const [getMsUserByToId, { data: privateLetter }] =
    useLazyGetMsUserByToIdQuery();
  const [getFollows, { data: followersList }] = useLazyGetFollowsQuery();
  const [getFans, { data: newFas }] = useLazyGetFansQuery();
  const [createFollow] = useCreateFollowMutation();
  const [deleteFollow] = useDeleteFollowMutation();

  // 未读系统消息数
  const unReadMsSystemNumn = useAppSelector(selectUnReadMsSystemNum);

  const handleChangeTab = (index: number) => {
    setTabIndex(index);
  };

  useEffect(()=>{
    getMsSystem({
      user_id: userId,
      limit: 9999,
    });
  },[unReadMsSystemNumn])

  // 组件挂载后获取初始数据
  useEffect(() => {
    if (tabIndex === 0) {
      getMsSystem({
        user_id: userId,
        limit: 9999,
      });
    }
    if (tabIndex === 1) {
      getMsUserByToId({ user_id: userId });
    }
    if (tabIndex === 2) {
      getFans(userId);
      getFollows(userId);
    }
  }, [tabIndex]);

  const handleClickDetail = async(msg: MsSystem) => {
    const unreadNum = unReadMsSystemNumn-1;
    setCurrentMsg(msg);
    sysMsgControl.onOpen();
    const res = await readMsSystem({ user_id: userId, message_id: msg.id });
    if(res){
      dispatch(updateUnReadMsSystemNum(unreadNum));
    }
  };

  const handleAllReadMsSystem = () => {
    systemMsg?.map(async (item) => {
      await readMsSystem({ user_id: userId, message_id: item.id });
    });
    dispatch(updateUnReadMsSystemNum(0));
  };

  const handleClickPrivateLetter = (form_id: string) => {
    setCurrentLetterUserId(form_id);
    prvLetterControl.onOpen();
  };

  // 回关
  const handleCreateFollow = async (follow: Follow) => {
    const followData = {
      id: follow.id,
      user_id: follow.user_id,
      followee_id: follow.followee_id,
      create_at: follow.create_at,
      update_at: follow.update_at,
      status: 0,
      permission: follow.permission,
      user: follow.user,
      contents: follow.contents,
    };
    await createFollow(followData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
  };

  // 取消关注
  const handleCancelFollow = async (follow: Follow) => {
    const followData = {
      ...follow,
      status: 1,
    };
    await deleteFollow(followData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
  };

  return (
    <Box minH="calc(100vh - 61px)" overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Tabs position="relative" variant="unstyled" onChange={handleChangeTab}>
          <Flex
            h="52px"
            justifyContent={"space-between"}
            alignItems="end"
            borderBottom={"1px solid #E0E0E0"}
          >
            <TabList color="#8E94A9">
              <Tab
                fontSize={"14px"}
                _selected={{ color: "#27314D", fontWeight: "bold" }}
              >
                <Text position={"relative"}>
                  系统消息
                  {unReadMsSystemNumn > 0 && (
                    <Box
                      position="absolute"
                      top="0"
                      right="-15px"
                      height="14px"
                      width="14px"
                      bg={"#ff0000"}
                      color="#fff"
                      fontSize={"8px"}
                      textAlign="center"
                      lineHeight={"14px"}
                      borderRadius="50%"
                    >
                      {unReadMsSystemNumn}
                    </Box>
                  )}
                </Text>
              </Tab>
              <Tab
                fontSize={"14px"}
                _selected={{ color: "#27314D", fontWeight: "bold" }}
              >
                私信
              </Tab>
              <Tab
                fontSize={"14px"}
                _selected={{ color: "#27314D", fontWeight: "bold" }}
              >
                新增关注
              </Tab>
            </TabList>
            <Box>
              {tabIndex === 0 && (
                <Button
                  fontSize={"14px"}
                  fontWeight="normal"
                  color={"#496AE1"}
                  variant="unstyled"
                  ml={"20px"}
                  onClick={handleAllReadMsSystem}
                >
                  全部标为已读
                </Button>
              )}

              {/* <Button
                fontSize={"14px"}
                fontWeight="normal"
                color={"#496AE1"}
                variant="unstyled"
                ml={"20px"}
              >
                清空
              </Button> */}
            </Box>
          </Flex>

          <TabIndicator
            mt="-1.5px"
            height="2px"
            bg="#27314D"
            borderRadius="1px"
          />

          <TabPanels>
            {/* 系统消息 */}
            <TabPanel>
              {!systemMsg?.length && (
                <Flex
                  minH={"calc(100vh - 149px - 2rem)"}
                  flexDir={"column"}
                  justifyContent={"center"}
                  alignItems="center"
                >
                  <Image src={noMessage} mb="30px" />
                  <Text fontSize={"14px"} color="#8E94A9">
                    没有未读的消息哦～
                  </Text>
                </Flex>
              )}

              {systemMsg &&
                systemMsg.length > 0 &&
                systemMsg.map((item, index) => {
                  return (
                    <Flex
                      key={index}
                      p={"10px"}
                      borderBottom="1px solid #DCE0EB"
                      pb="30px"
                      pt="35px"
                      _hover={{
                        bg: "rgba(238, 241, 247, 0.5)",
                      }}
                    >
                      <Avatar size="sm" mr="18px" src={sysAvatar} />
                      <Box>
                        <Flex>
                          <Box>
                            <Text
                              display={"inline"}
                              fontWeight="700"
                              mr="10px"
                              color={"#27314D"}
                              fontSize="13px"
                            >
                              系统消息
                            </Text>
                            <Text fontSize="13px" display={"inline"}>
                              {item.title}
                            </Text>
                          </Box>
                          <Button
                            ml="18px"
                            color="#496AE1"
                            fontWeight={"normal"}
                            fontSize="13px"
                            variant="link"
                            onClick={() => handleClickDetail(item)}
                          >
                            点击查看
                          </Button>
                        </Flex>
                        <Box mt="10px" color={"#8E94A9"} fontSize="10px">
                          {format(new Date(item.createat), "yyyy/MM/dd")}
                        </Box>
                      </Box>
                    </Flex>
                  );
                })}
            </TabPanel>
            {/* 私信 */}
            <TabPanel>
              {!privateLetter?.length && (
                <Flex
                  minH={"calc(100vh - 149px - 2rem)"}
                  flexDir={"column"}
                  justifyContent={"center"}
                  alignItems="center"
                >
                  <Image src={noMessage} mb="30px" />
                  <Text fontSize={"14px"} color="#8E94A9">
                    没有未读的消息哦～
                  </Text>
                </Flex>
              )}

              {privateLetter &&
                privateLetter.length > 0 &&
                privateLetter.map((item, index) => {
                  return (
                    // <Box key={index}>
                    //   <PrivateLetterItem letter={item} />
                    // </Box>
                    <Flex
                      p="10px"
                      key={index}
                      // justifyContent="space-between"
                      borderBottom="1px solid #DCE0EB"
                      pb="30px"
                      pt="35px"
                      _hover={{
                        bg: "rgba(238, 241, 247, 0.5)",
                      }}
                    >
                      <Flex mr={"10px"}>
                        <Avatar
                          size="sm"
                          mr="18px"
                          src={`/api/v4/users/${item.from_user.id}/image`}
                        />
                        <Box>
                          <Box
                            mb="6px"
                            fontWeight="700"
                            color={"#27314D"}
                            fontSize="13px"
                          >
                            {item.from_user.user_name}
                          </Box>
                          <Box fontSize="13px" display={"inline"}>
                            {item.content}
                          </Box>
                          <Box mt="10px" color={"#8E94A9"} fontSize="10px">
                            {item.createat}
                          </Box>
                        </Box>
                      </Flex>
                      <Button
                        ml="18px"
                        color="#496AE1"
                        fontWeight={"normal"}
                        fontSize="13px"
                        variant="link"
                        onClick={() => handleClickPrivateLetter(item.form_id)}
                      >
                        点击查看
                      </Button>
                    </Flex>
                  );
                })}
            </TabPanel>
            {/* 新增关注 */}
            <TabPanel>
              {!newFas?.length && (
                <Flex
                  minH={"calc(100vh - 149px - 2rem)"}
                  flexDir={"column"}
                  justifyContent={"center"}
                  alignItems="center"
                >
                  <Image src={noMessage} mb="30px" />
                  <Text fontSize={"14px"} color="#8E94A9">
                    没有未读的消息哦～
                  </Text>
                </Flex>
              )}

              {newFas &&
                newFas.length > 0 &&
                newFas.map((item, index) => {
                  const hasFollowThisFan = followersList?.some(
                    (obj) => obj.user_id === item.user_id
                  );
                  return (
                    <Flex
                      p="10px"
                      key={index}
                      justifyContent="space-between"
                      _hover={{
                        bg: "rgba(238, 241, 247, 0.5)",
                      }}
                      borderBottom="1px solid #DCE0EB"
                      pb="30px"
                      pt="35px"
                    >
                      <Flex mr={"10px"} flex={1}>
                        <Avatar
                          size="sm"
                          mr="18px"
                          src={`/api/v4/users/${item.user_id}/image`}
                        />
                        <Box>
                          <Box
                            mb="6px"
                            fontWeight="700"
                            color={"#27314D"}
                            fontSize="13px"
                          >
                            {item.user.username}
                          </Box>
                          <Box fontSize="13px" display={"inline"}>
                            开始关注了你
                          </Box>
                          <Box mt="10px" color={"#8E94A9"} fontSize="10px">
                            {item.create_at}
                          </Box>
                        </Box>
                      </Flex>
                      {!hasFollowThisFan && (
                        <Button
                          borderRadius={"40px"}
                          width={"80px"}
                          height={"33px"}
                          color="#FFFFFF"
                          bgColor="#496AE1"
                          border={"none"}
                          fontSize="12px"
                          _hover={{
                            color: "##E6E6E6",
                            bgColor: "#3F5BC1",
                            border: "1px solid #8E94A9",
                          }}
                          onClick={() => handleCreateFollow(item)}
                        >
                          回关
                        </Button>
                      )}

                      {hasFollowThisFan && (
                        <Button
                          borderRadius={"40px"}
                          width={"80px"}
                          height={"33px"}
                          color="#27314D"
                          bgColor="#fff"
                          border={"1px solid #8E94A9"}
                          fontSize="12px"
                          _hover={{
                            color: "#27314D",
                            bgColor: "#CBD1DF",
                            border: "1px solid #8E94A9",
                          }}
                          onClick={() => handleCancelFollow(item)}
                        >
                          已关注
                        </Button>
                      )}
                    </Flex>
                  );
                })}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
      {currentMsg && (
        <SysMsgModal
          isOpen={sysMsgControl.isOpen}
          onClose={sysMsgControl.onClose}
          message={currentMsg}
        />
      )}
      <PrivateLetterModal
        isOpen={prvLetterControl.isOpen}
        onClose={prvLetterControl.onClose}
        curUserId={currentLetterUserId}
      />
    </Box>
  );
};

export default MessagesCenter;
